/* Do not edit directly — generated by scripts/tokens/build.mjs */

export const theme = {
  neutralBackgroundBase: "var(--neutral-background-base)",
  neutralBackgroundMedium: "var(--neutral-background-medium)",
  neutralBackground: "var(--neutral-background)",
  neutralBackgroundHover: "var(--neutral-background-hover)",
  neutralBackgroundActive: "var(--neutral-background-active)",
  neutralBackgroundExtraDark: "var(--neutral-background-extra-dark)",
  neutralText: "var(--neutral-text)",
  neutralTextWeak: "var(--neutral-text-weak)",
  neutralTextDisabled: "var(--neutral-text-disabled)",
  neutralBorder: "var(--neutral-border)",
  neutralBorderMedium: "var(--neutral-border-medium)",
  neutralScrim: "var(--neutral-scrim)",
  neutralBackgroundTransparent: "var(--neutral-background-transparent)",
  neutralBorderStrong: "var(--neutral-border-strong)",
  primaryAction: "var(--primary-action)",
  primaryActionHover: "var(--primary-action-hover)",
  primaryActionActive: "var(--primary-action-active)",
  primaryBackground: "var(--primary-background)",
  primaryBackgroundMedium: "var(--primary-background-medium)",
  primaryBackgroundActive: "var(--primary-background-active)",
  primaryBackgroundStrong: "var(--primary-background-strong)",
  primaryBackgroundStrongHover: "var(--primary-background-strong-hover)",
  primaryBackgroundStrongActive: "var(--primary-background-strong-active)",
  primaryTextStrong: "var(--primary-text-strong)",
  primaryText: "var(--primary-text)",
  primaryTextHover: "var(--primary-text-hover)",
  primaryBorder: "var(--primary-border)",
  primaryTextStrongHover: "var(--primary-text-strong-hover)",
  primaryTextStrongActive: "var(--primary-text-strong-active)",
  alertBackground: "var(--alert-background)",
  alertBackgroundMedium: "var(--alert-background-medium)",
  alertBackgroundActive: "var(--alert-background-active)",
  alertBackgroundStrong: "var(--alert-background-strong)",
  alertBackgroundStrongHover: "var(--alert-background-strong-hover)",
  alertBackgroundStrongActive: "var(--alert-background-strong-active)",
  alertText: "var(--alert-text)",
  alertTextHover: "var(--alert-text-hover)",
  alertBorder: "var(--alert-border)",
  warningBackground: "var(--warning-background)",
  warningBackgroundMedium: "var(--warning-background-medium)",
  warningBackgroundActive: "var(--warning-background-active)",
  warningBackgroundStrong: "var(--warning-background-strong)",
  warningBackgroundStrongHover: "var(--warning-background-strong-hover)",
  warningBackgroundStrongActive: "var(--warning-background-strong-active)",
  warningText: "var(--warning-text)",
  warningTextHover: "var(--warning-text-hover)",
  warningBorder: "var(--warning-border)",
  successBackground: "var(--success-background)",
  successBackgroundMedium: "var(--success-background-medium)",
  successBackgroundActive: "var(--success-background-active)",
  successBackgroundStrong: "var(--success-background-strong)",
  successBackgroundStrongHover: "var(--success-background-strong-hover)",
  successBackgroundStrongActive: "var(--success-background-strong-active)",
  successText: "var(--success-text)",
  successTextHover: "var(--success-text-hover)",
  successBorder: "var(--success-border)",
  datavizQualitative121: "var(--dataviz-qualitative-12-1)",
  datavizQualitative122: "var(--dataviz-qualitative-12-2)",
  datavizQualitative123: "var(--dataviz-qualitative-12-3)",
  datavizQualitative124: "var(--dataviz-qualitative-12-4)",
  datavizQualitative125: "var(--dataviz-qualitative-12-5)",
  datavizQualitative126: "var(--dataviz-qualitative-12-6)",
  datavizQualitative127: "var(--dataviz-qualitative-12-7)",
  datavizQualitative128: "var(--dataviz-qualitative-12-8)",
  datavizQualitative129: "var(--dataviz-qualitative-12-9)",
  datavizQualitative1210: "var(--dataviz-qualitative-12-10)",
  datavizQualitative1211: "var(--dataviz-qualitative-12-11)",
  datavizQualitative1212: "var(--dataviz-qualitative-12-12)",
  datavizQualitative41: "var(--dataviz-qualitative-4-1)",
  datavizQualitative42: "var(--dataviz-qualitative-4-2)",
  datavizQualitative43: "var(--dataviz-qualitative-4-3)",
  datavizQualitative44: "var(--dataviz-qualitative-4-4)",
  datavizQualitative211: "var(--dataviz-qualitative-2-1-1)",
  datavizQualitative212: "var(--dataviz-qualitative-2-1-2)",
  datavizQualitative221: "var(--dataviz-qualitative-2-2-1)",
  datavizQualitative222: "var(--dataviz-qualitative-2-2-2)",
  datavizSequential711: "var(--dataviz-sequential-7-1-1)",
  datavizSequential712: "var(--dataviz-sequential-7-1-2)",
  datavizSequential713: "var(--dataviz-sequential-7-1-3)",
  datavizSequential714: "var(--dataviz-sequential-7-1-4)",
  datavizSequential715: "var(--dataviz-sequential-7-1-5)",
  datavizSequential716: "var(--dataviz-sequential-7-1-6)",
  datavizSequential717: "var(--dataviz-sequential-7-1-7)",
  datavizSequential721: "var(--dataviz-sequential-7-2-1)",
  datavizSequential722: "var(--dataviz-sequential-7-2-2)",
  datavizSequential723: "var(--dataviz-sequential-7-2-3)",
  datavizSequential724: "var(--dataviz-sequential-7-2-4)",
  datavizSequential725: "var(--dataviz-sequential-7-2-5)",
  datavizSequential726: "var(--dataviz-sequential-7-2-6)",
  datavizSequential727: "var(--dataviz-sequential-7-2-7)",
  datavizSequential731: "var(--dataviz-sequential-7-3-1)",
  datavizSequential732: "var(--dataviz-sequential-7-3-2)",
  datavizSequential733: "var(--dataviz-sequential-7-3-3)",
  datavizSequential734: "var(--dataviz-sequential-7-3-4)",
  datavizSequential735: "var(--dataviz-sequential-7-3-5)",
  datavizSequential736: "var(--dataviz-sequential-7-3-6)",
  datavizSequential737: "var(--dataviz-sequential-7-3-7)",
  datavizSequential741: "var(--dataviz-sequential-7-4-1)",
  datavizSequential742: "var(--dataviz-sequential-7-4-2)",
  datavizSequential743: "var(--dataviz-sequential-7-4-3)",
  datavizSequential744: "var(--dataviz-sequential-7-4-4)",
  datavizSequential745: "var(--dataviz-sequential-7-4-5)",
  datavizSequential746: "var(--dataviz-sequential-7-4-6)",
  datavizSequential747: "var(--dataviz-sequential-7-4-7)",
  datavizDiverging911: "var(--dataviz-diverging-9-1-1)",
  datavizDiverging912: "var(--dataviz-diverging-9-1-2)",
  datavizDiverging913: "var(--dataviz-diverging-9-1-3)",
  datavizDiverging914: "var(--dataviz-diverging-9-1-4)",
  datavizDiverging915: "var(--dataviz-diverging-9-1-5)",
  datavizDiverging916: "var(--dataviz-diverging-9-1-6)",
  datavizDiverging917: "var(--dataviz-diverging-9-1-7)",
  datavizDiverging918: "var(--dataviz-diverging-9-1-8)",
  datavizDiverging919: "var(--dataviz-diverging-9-1-9)",
  datavizDiverging921: "var(--dataviz-diverging-9-2-1)",
  datavizDiverging922: "var(--dataviz-diverging-9-2-2)",
  datavizDiverging923: "var(--dataviz-diverging-9-2-3)",
  datavizDiverging924: "var(--dataviz-diverging-9-2-4)",
  datavizDiverging925: "var(--dataviz-diverging-9-2-5)",
  datavizDiverging926: "var(--dataviz-diverging-9-2-6)",
  datavizDiverging927: "var(--dataviz-diverging-9-2-7)",
  datavizDiverging928: "var(--dataviz-diverging-9-2-8)",
  datavizDiverging929: "var(--dataviz-diverging-9-2-9)",
  focusRing: "var(--focus-ring)",
  standoutBackground: "var(--standout-background)",
  standoutBackgroundHover: "var(--standout-background-hover)",
  standoutBackgroundActive: "var(--standout-background-active)",
  standoutText: "var(--standout-text)",
  buttonPrimaryStrong: "var(--button-primary-strong)",
  buttonPrimaryStrongHover: "var(--button-primary-strong-hover)",
  buttonPrimaryStrongActive: "var(--button-primary-strong-active)",
  buttonDestructiveStrong: "var(--button-destructive-strong)",
  buttonDestructiveStrongHover: "var(--button-destructive-strong-hover)",
  buttonDestructiveStrongActive: "var(--button-destructive-strong-active)",
  buttonOnStrong: "var(--button-on-strong)",
  badgeFill: "var(--badge-fill)",
} as const;
